import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-button-wizard-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.olapButtonWizardDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.buttonsWizard.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.wizardButtons,
        class: "p-datatable-sm kn-table p-m-4",
        scrollable: true,
        scrollHeight: "100%"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: _ctx.$t('common.name')
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.olapButtonWizardDialogDescriptor.buttonLabels[slotProps.data.name])), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('common.visible')
          }, {
            header: _withCtx(() => [
              _createVNode(_component_Checkbox, {
                class: "p-mr-2",
                modelValue: _ctx.allVisibleSelected,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.allVisibleSelected = $event)),
                binary: true,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAllChecked('visible')))
              }, null, 8, ["modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data.visible,
                "onUpdate:modelValue": ($event: any) => (slotProps.data.visible = $event),
                binary: true,
                onChange: ($event: any) => (_ctx.setChecked(slotProps.data, 'visible'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('common.clicked')
          }, {
            header: _withCtx(() => [
              _createVNode(_component_Checkbox, {
                class: "p-mr-2",
                modelValue: _ctx.allClickedSelected,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.allClickedSelected = $event)),
                binary: true,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAllChecked('clicked')))
              }, null, 8, ["modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data.clicked,
                "onUpdate:modelValue": ($event: any) => (slotProps.data.clicked = $event),
                binary: true,
                disabled: !slotProps.data.clickable,
                onChange: ($event: any) => (_ctx.setChecked(slotProps.data, 'clicked'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}